import React from "react";
import T from "prop-types";

export default function EmailLink({ email }) {
  const handleMailto = e => {
    e.stopPropagation();
  };

  return (
    <a href={`mailto:${email}`} onClick={handleMailto}>
      {email}
    </a>
  );
}

EmailLink.propTypes = {
  email: T.string.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/EmailLink/EmailLink.jsx